<!-- Header -->
<div class="bb-page-header">
  <div class="bb-page-title-block">
    <span class="bb-eyebrow">{{ "delivery heroes" | transloco }}</span>
    <h2 class="bb-page-title">{{ "delivery heroes" | transloco }}</h2>
    <p class="bb-page-subtitle">{{ "Manage your delivery team" | transloco }}</p>
  </div>

  <div class="bb-header-actions">
    <button routerLink="/adddeliveryhero" class="bb-btn bb-btn-primary">
      {{ "new delivery hero" | transloco }}
    </button>

    <button routerLink="/deliveryfees" class="bb-btn bb-btn-secondary">
      {{ "delivery fees" | transloco }}
    </button>

    <button routerLink="/herosmap" class="bb-btn bb-btn-secondary">
      {{ "maps" | transloco }}
    </button>

    @if(isAdmin){
    <div class="bb-action-dropdown dropdown">
      <button class="bb-btn bb-btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown">
        {{ "Pospage" | transloco }}
      </button>

      <ul class="bb-dropdown-menu dropdown-menu">
        <li *ngFor="let el of allWareHouses">
          <a class="bb-dropdown-item dropdown-item" (click)="applyWareHouse(el.id)">
            {{el.name}}
          </a>
        </li>
      </ul>
    </div>
    }
  </div>
</div>

<!-- Card -->
<div class="bb-card bb-p-20">
  <div class="bb-table-scroll">
    <table mat-table [dataSource]="dataSource" class="bb-table table-custom mat-elevation-z0">

      <!-- Name -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
          {{ "Name" | transloco }}
        </th>

        <td mat-cell *matCellDef="let element" class="mat-cell-custom">
          <div class="bb-inline-flex bb-items-center bb-gap-12">
            <div class="bb-client-avatar">
              <img
                *ngIf="element.image_url"
                [src]="fixUrl(element.image_url)"
                class="bb-w-100 bb-h-100 bb-rounded-full"
              />
              <span *ngIf="!element.image_url">
                {{ element.name?.charAt(0) }}
              </span>
            </div>

            <span class="bb-font-semibold bb-text-navy">
              {{ element.name }}
            </span>
          </div>
        </td>
      </ng-container>

      <!-- National ID -->
      <ng-container matColumnDef="national_id">
        <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
          {{ "grov_id" | transloco }}
        </th>
        <td mat-cell *matCellDef="let element" class="mat-cell-custom">
          {{ element.national_id || '-' }}
        </td>
      </ng-container>

      <!-- Phone -->
      <ng-container matColumnDef="phone">
        <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
          {{ "phone" | transloco }}
        </th>
        <td mat-cell *matCellDef="let element" class="mat-cell-custom">
          {{ element.phone || '-' }}
        </td>
      </ng-container>

      <!-- Delivery Method -->
      <ng-container matColumnDef="method">
        <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
          {{ "delivery method" | transloco }}
        </th>
        <td mat-cell *matCellDef="let element" class="mat-cell-custom">
          <span class="bb-badge bb-badge-soft-blue">
            {{ element.method }}
          </span>
        </td>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom bb-actions-th">
        </th>

        <td mat-cell *matCellDef="let element" class="mat-cell-custom bb-actions-td">
          <div class="bb-action-dropdown dropdown">
            <button
              class="bb-icon-btn action-btn menu"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              title="{{ 'Actions' | transloco }}"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <circle cx="12" cy="5" r="2" />
                <circle cx="12" cy="12" r="2" />
                <circle cx="12" cy="19" r="2" />
              </svg>
            </button>

            <ul class="bb-dropdown-menu dropdown-menu dropdown-menu-end">
              <li>
                <a class="bb-dropdown-item dropdown-item text-danger" (click)="deleteitem(element.id)">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
                  </svg>
                  {{ "Delete" | transloco }}
                </a>
              </li>
            </ul>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="mat-header-row-custom"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="mat-row-custom"></tr>

    </table>
  </div>

  <mat-paginator
    [length]="stockTotal"
    [pageSize]="10"
    (page)="onPaginateChange($event)"
    class="bb-paginator custom-paginator">
  </mat-paginator>
</div>